const adCheck = ads => {
    for (let i = 0; i < ads.length; i++) {
        if (window.adUtility.elementInView(ads[i])) {
            let ad = document.getElementById(ads[i])
            window.adUtility.refresh(ad)
        }
    }
}

let adRefreshTimer = 0
const adsRefresh = store => next => action => {
    switch (action.type) {
        case 'ADS_REFRESH_EVENT':
            clearTimeout(adRefreshTimer)
            if (typeof window.adUtility !== 'undefined') {
                try {
                    adRefreshTimer = setTimeout(() => {
                        window.adUtility.resetAll(window.adutil_target)
                    }, 2000)
                } catch (e) {
                    console.log(e)
                }
            }
            break

        case 'BAT_ADS_EVENT':
            if (typeof window.adUtility !== 'undefined') {
                try {
                    var adIds = ['bigbox_ad_01', 'leaderboard_01']
                    adCheck(adIds)
                } catch (e) {
                    console.log(e)
                }
            }
            break

        case 'INIT_HEADER_LEADERBOARD_AD':
            if (typeof window.adUtility !== 'undefined') {
                try {
                    if (window.snBreakpointWatcher.breakPoint() >= 768) {
                        window.adUtility.insertAd('leaderboard', {
                            type: window.adUtility._AD_LEADERBOARD_MASTER,
                            adPath: window.adUtility.adPath,
                            targeting: action.targeting,
                        })
                    }
                } catch (e) {
                    console.log(e)
                }
            }
            break

        case 'INIT_LIVETRACKER_SPONSOR_DESKTOP_AD':
            if (typeof window.adUtility !== 'undefined') {
                try {
                    if (!store.getState().isMobileApp) {
                        if (window.innerWidth >= 768) {
                            // kill sponsor_00 div in header if it happens to exists already - only for NON template basic
                            if (document.querySelector('.sn-sponsor-ad') !== null) {
                                document.getElementsByClassName('sn-sponsor-ad')[0].outerHTML = ''
                            }
                            window.adUtility.insertAd('sponsor_00', {
                                type: window.adUtility._AD_SPONSORSHIP_BUTTON,
                                adPath: '/7326/en.sportsnet.web/hockey/nhl/livetracker',
                                targeting: typeof window.adTargets === 'function' ? window.adTargets() : '',
                            })
                        }
                    } else {
                        window.adUtility.insertAd('sponsor_00', {
                            type: window.adUtility._AD_SPONSORSHIP_BUTTON,
                            adPath: '/7326/en.sportsnet.web/hockey/nhl/livetracker',
                            targeting: typeof window.adTargets === 'function' ? window.adTargets() : '',
                        }) // add in sponsor logo for template basic
                    }
                } catch (e) {
                    console.log(e)
                }
            }
            break

        // case 'INIT_COMPONENT_SPONSOR_AD':
        //   if (typeof window.adUtility !== "undefined") {
        //   	try {
        //       window.adUtility.insertAd("sponsor_00", {type: window.adUtility._AD_SPONSORSHIP_BUTTON});
        //     } catch(e) {
        //     	console.log(e);
        //     }
        //   }
        // break;

        case 'CREATE_ADUTIL_TARGET':
            window.adutil_target = {
                game_status: action.status,
                period: action.period ? action.period.toString() : '0',
                visiting_team: action.visiting_team,
                visiting_strength: action.visiting_strength,
                home_team: action.home_team,
                home_strength: action.home_strength,
            }
            break

        case 'REFRESH_ADUTIL_TARGET':
            window.adutil_target = {}
            break

        default:
            return next(action)
    }
}

export default adsRefresh
